export default __webpack_public_path__ + "static/media/wallet.bc6be1a9.svg";